import React, { useEffect, useState } from 'react';
import { Form, Input, Row, message } from 'antd';
import { identity } from 'lodash';

import InspectionService from 'services/inspection';
import { errHandling } from 'utils';
import PdButton from 'components/pd-button';

export function UpdateInspectionSerialNumberForm({
  inspection: { id, serial_number } = {},
  onSubmitSuccess = identity,
}) {
  const [loadingButton, setLoadingButton] = useState(false);
  const [serialNumber, setSerialNumber] = useState('');

  async function onSubmitSerialNumber(ev) {
    ev.preventDefault();
    if (!serialNumber) {
      return message.error('Please input the serial number');
    }
    setLoadingButton(true);
    try {
      const payload = {
        inspection: {
          serial_number: serialNumber,
        },
      };
      await InspectionService.updateInspectionSerialNumber(id, payload);
      onSubmitSuccess();
    } catch (error) {
      errHandling(error);
    } finally {
      setLoadingButton(false);
    }
  }

  function handleOnChange({ target: { value } }) {
    setSerialNumber(value);
  }

  useEffect(() => {
    setSerialNumber(serial_number);
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      className="pd-checking-inspection-form"
      onSubmit={onSubmitSerialNumber}>
      <div className="section-container">
        <div className="inner-section">
          <Form.Item>
            <Input
              onChange={handleOnChange}
              placeholder="Set Serial Number"
              value={serialNumber}
            />
          </Form.Item>
        </div>
      </div>

      <div className="button-container">
        <Form.Item>
          <Row type="flex" justify="center">
            <PdButton
              className="w-half height-32"
              full
              htmlType="submit"
              loading={loadingButton}
              type="primary">
              Save
            </PdButton>
          </Row>
        </Form.Item>
      </div>
    </Form>
  );
}
